<template>
<span>
    <v-btn @click="initCreate">
        <v-icon left small>fas fa-plus-circle</v-icon>
        Add Media
    </v-btn>

    <v-dialog v-model="createModal">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
            <v-card class="MediaModal">
                <ModalOverlay></ModalOverlay>
                <v-card-title>
                    <h1>Add Media</h1>
                    <v-spacer/>
                    <v-btn type="button" text @click="closeCreateModal">Close</v-btn>
                    <v-btn form="createForm" type="submit" color="primary" :disabled="invalid">
                        <v-icon small left>fas fa-save</v-icon>
                        Save
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <form @submit.prevent="handleSubmit(create)" id="createForm">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-alert v-if="errorMessage" type="error"
                                         style="margin-bottom: 42px !important;">{{ errorMessage }}</v-alert>
                                <ValidationProvider v-slot="{ errors }" name="File"
                                                    rules="ext:jpg,jpeg,png,pdf|required">
                                    <v-file-input outlined
                                                  label="Select File"
                                                  @change="selectFile"
                                                  :error-messages="errors"
                                                  required
                                                  v-model="currentFile"
                                    ></v-file-input>
                                </ValidationProvider>
                                <div class="MediaModal__imagePreview">
                                    <img v-if="previewSrc" :src="previewSrc" alt="">
                                </div>
                            </v-col>
                            <v-col cols="12" md="8">
                                 <TagMedia/>
                            </v-col>
                        </v-row>
                    </form>
                </v-card-text>
            </v-card>
        </ValidationObserver>
    </v-dialog>
</span>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store/store';
import ModalOverlay from '@/components/ModalOverlay';
import MediaCrudMixin from '@/views/Admin/MediaLibrary/MediaCrudMixin';
import TagMedia from '@/views/Admin/MediaLibrary/TagMedia';

export default {
    components: { TagMedia, ModalOverlay },
    mixins: [MediaCrudMixin],

    props: [],

    computed: {
        ...mapState('mediaLibrary', ['files', 'tableLoading', 'mediaId']),

        selectedFields: {
            get: function() {
                return store.state.mediaLibrary.selectedFields;
            },
            set: function(value) {
                this.setSelectedFields(value);
            }
        },

        errorMessage: {
            get: function() {
                return store.state.mediaLibrary.errorMessage;
            },
            set: function(value) {
                this.setErrorMessage(value);
            }
        },

        currentSrc: {
            get: function() {
                return store.state.mediaLibrary.currentSrc;
            },
            set: function(value) {
                this.setCurrentSrc(value);
            }
        },

        deleteModal: {
            get: function() {
                return store.state.mediaLibrary.deleteModal;
            },
            set: function(value) {
                this.toggleDeleteModal(value);
            }
        },

        createModal: {
            get: function() {
                return store.state.mediaLibrary.createModal;
            },
            set: function(value) {
                this.toggleCreateModal(value);
            }
        },

        editModal: {
            get: function() {
                return store.state.mediaLibrary.editModal;
            },
            set: function(value) {
                this.toggleEditModal(value);
            }
        },

        viewModal: {
            get: function() {
                return store.state.mediaLibrary.viewModal;
            },
            set: function(value) {
                this.toggleViewModal(value);
            }
        }
    },

    data() {
        return {
            previewSrc: ''
        };
    },

    mounted() {
    },

    methods: {
        ...mapMutations({
            toggleCreateModal: 'mediaLibrary/toggleCreateModal',
            setSelectedFields: 'mediaLibrary/setSelectedFields'
        }),

        ...mapActions({
            createMedia: 'mediaLibrary/createMedia'
        }),

        initCreate() {
            this.setCurrentSrc(null);
            this.setCurrentFile(null);
            this.setSelectedFields([]);
            this.setProfession(this.getProfessionIds([]));
            this.setMediaId(null)
                .then(() => {
                    this.toggleCreateModal(true);
                });
        },

        selectFile(file) {
            this.previewFile();
            this.setErrorMessage(false);
            this.setCurrentFile(file);
        },

        create() {
            this.toggleOverlay(true);
            this.createMedia()
                .then(() => {
                    this.toggleOverlay(false);
                    this.closeCreateModal();
                })
                .catch(() => {
                    this.toggleOverlay(false);
                });
        },

        previewFile() {
            let file = this.currentFile;
            let reader = new FileReader();
            const _this = this;

            reader.onloadend = function() {
                _this.previewSrc = reader.result;
            };

            if (file) {
                reader.readAsDataURL(file);
            } else {
                this.previewSrc = '';
            }
        },

        closeCreateModal() {
            this.setCurrentSrc('');
            this.setSelectedFields([]);
            this.setProfession([]);
            this.setMediaId('');
            this.previewSrc = '';
            this.toggleCreateModal(false);
        }
    }
};
</script>
<style lang="scss">
.MediaModal__imagePreview {
    flex: 0 0 100%;
    width: 100%;

    img {
        width: 100%;
        height: auto;
    }
}
</style>
